import { TokenAmount } from "@/components";
import type { TokenId } from "@/types";

interface ToastDetailRowProps {
    label: string;
    amount: number;
    tokenId: TokenId;
}

export function ToastDetailRow({ label, amount, tokenId }: ToastDetailRowProps) {
    return (
        <>
            <div className="text-gray-400">{label}</div>
            <TokenAmount amount={amount} tokenId={tokenId} size="md" />
        </>
    );
}
